import React from 'react';
import climateImage from '../assets/images/klima.png';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaCheck, FaSnowflake, FaTools, FaLeaf } from 'react-icons/fa';

const Klima: React.FC = () => {
  const services = [
    {
      icon: <FaSnowflake className="text-3xl text-blue-500" />,
      title: "Gyors és szakszerű telepítés",
      description: "Professzionális klíma telepítés minden típusú épületben.",
      features: ["Helyszíni felmérés", "Optimális elhelyezés", "Szakszerű szerelés", "Próbaüzem"]
    },
    {
      icon: <FaTools className="text-3xl text-gray-600" />,
      title: "Tisztítás és karbantartás",
      description: "Rendszeres karbantartás a hosszú élettartamért.",
      features: ["Szűrő tisztítás", "Antibakteriális kezelés", "Teljesítmény ellenőrzés", "Megelőző karbantartás"]
    },
    {
      icon: <FaLeaf className="text-3xl text-green-500" />,
      title: "Energiatakarékos megoldások",
      description: "H TARIFA igénylés és energiahatékony rendszerek.",
      features: ["Inverteres technológia", "Energiaosztály A+++", "H TARIFA ügyintézés", "Költséghatékonyság"]
    }
  ];

  const advantages = [
    "Szakképzett szerelők",
    "Minőségi márkaképviselet",
    "Garanciális szolgáltatás",
    "Gyors kiszállás",
    "Versenyképes árak",
    "Teljes körű szerviz"
  ];

  const brands = [
    "Daikin", "Mitsubishi", "Samsung", "LG", "Panasonic", "Fujitsu", "AUX", "GREE"
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-96 bg-gradient-to-r from-blue-500 to-blue-700 overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src={climateImage} 
            alt="Klíma telepítés" 
            className="w-full h-full object-cover opacity-20"
          />
        </div>
        <div className="relative z-10 container mx-auto px-4 h-full flex items-center">
          <div className="text-white max-w-2xl">
            <h1 className="text-4xl md:text-6xl font-bold mb-4">
              Klíma Telepítés
            </h1>
            <p className="text-xl md:text-2xl mb-6">
              Hűvös nyarak és meleg telek garantáltan
            </p>
            <a 
              href="/#contact"
              className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
            >
              Ajánlatot kérek
            </a>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800">
            Szolgáltatásaink
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow text-center">
                <div className="mb-4">{service.icon}</div>
                <h3 className="text-xl font-bold mb-4 text-blue-600">{service.title}</h3>
                <p className="text-gray-600 mb-4">{service.description}</p>
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-gray-700">
                      <FaCheck className="text-blue-600 mr-2" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Brands Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800">
            Partnereink
          </h2>
          
          <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-8 gap-3">
            {brands.map((brand, index) => (
              <div key={index} className="bg-gray-50 p-3 rounded-lg text-center hover:shadow-md transition-shadow">
                <span className="text-base font-semibold text-gray-700">{brand}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* H TARIFA Section */}
      <section className="py-16 bg-green-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gray-800">
              H TARIFA Igénylés
            </h2>
            <p className="text-xl mb-8 text-gray-600">
              Hőszivattyús rendszerek esetén kedvezményes áramtarifa igényelhető
            </p>
            
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white p-6 rounded-lg shadow">
                <h3 className="text-xl font-bold mb-4 text-green-600">Kedvezmény</h3>
                <p className="text-gray-700">Akár 30%-os megtakarítás a fűtési költségeken</p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow">
                <h3 className="text-xl font-bold mb-4 text-green-600">Ügyintézés</h3>
                <p className="text-gray-700">Teljes körű hivatalos ügyintézés</p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow">
                <h3 className="text-xl font-bold mb-4 text-green-600">Támogatás</h3>
                <p className="text-gray-700">Szakértői segítség a folyamat során</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Advantages Section */}
      <section className="py-16 bg-blue-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800">
            Miért válasszon minket?
          </h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-4xl mx-auto">
            {advantages.map((advantage, index) => (
              <div key={index} className="flex items-center bg-white p-4 rounded-lg shadow">
                <FaCheck className="text-blue-600 mr-3 text-xl" />
                <span className="text-gray-800 font-medium">{advantage}</span>
              </div>
            ))}
          </div>
        </div>
      </section>



      {/* Contact Section */}
      <section className="py-16 bg-gray-900 text-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-12">
            Kérjen Árajánlatot!
          </h2>
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div>
              <h3 className="text-2xl font-semibold mb-6">Elérhetőségeink</h3>
              <div className="space-y-4">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center text-white text-xl">
                    📞
                  </div>
                  <div>
                    <div className="font-medium">Nagy Péter Villanyszerelő mester</div>
                    <a 
                      href="tel:+36703620652"
                      className="text-red-400 hover:text-red-300 font-semibold transition-colors"
                    >
                      +36703620652
                    </a>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center text-white text-xl">
                    📞
                  </div>
                  <div>
                    <div className="font-medium">Tamasi Krisztán villamosbiztonsági felülvizsgáló</div>
                    <a 
                      href="tel:+36706049889"
                      className="text-red-400 hover:text-red-300 font-semibold transition-colors"
                    >
                      +36706049889
                    </a>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center text-white text-xl">
                    ✉️
                  </div>
                  <div>
                    <a 
                      href="mailto:kelectrokft@gmail.com"
                      className="hover:text-red-400 transition-colors"
                    >
                      kelectrokft@gmail.com
                    </a>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center text-white text-xl">
                    📍
                  </div>
                  <div>
                    <span>SZOLNOK és 100km-es körzete</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-800 p-6 rounded-xl">
              <h3 className="text-xl font-semibold mb-4">Gyors kapcsolatfelvétel</h3>
              <p className="text-gray-300 mb-4">
                Hívjon minket bizalommal! Ingyenes helyszíni felméréssel és 
                részletes árajánlattal várjuk megkeresését.
              </p>
              <div className="space-y-2">
                <p className="text-red-400 font-semibold">📞 Azonnali válasz</p>
                <p className="text-red-400 font-semibold">📋 Ingyenes felmérés</p>
                <p className="text-red-400 font-semibold">💰 Versenyképes árak</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Klima; 